<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStrategyTags } from '../useStrategyTags'
import { subjectOptions } from '../strategy_filters'

const props = withDefaults(defineProps<{ title: string; tags?: string[] }>(), { tags: () => [] })

const CRUMB_LINK_CLASSES = 'text-blue-400 hover:text-blue-600 hover:underline focus:text-blue-600 focus:underline'

const route = useRoute()
const { tags: strategyTags } = useStrategyTags()

const betaQuery = computed(() => (typeof route.query.beta === 'string' ? { beta: route.query.beta } : {}))

const subjects = computed(() =>
  subjectOptions(strategyTags.value).filter(
    (subject) => props.tags.includes(subject.value as string) || props.tags.includes(subject.label)
  )
)
</script>

<template>
  <!-- The spaces between the inline-block crumbs are Bootstrap's crumb spacing, so each </li> <li> stays on one line -->
  <ol
    class="mb-5 list-none rounded-xs bg-gray-100 px-[15px] py-2 text-text-md leading-5 text-gray-900 [&>li+li]:before:px-[5px] [&>li+li]:before:text-gray-800 [&>li+li]:before:content-['/\00a0']"
  >
    <li class="inline-block">
      <router-link :to="{ name: 'StrategyIndex', query: betaQuery }" :class="CRUMB_LINK_CLASSES">
        UDL Strategy Index
      </router-link>
    </li> <li class="inline-block">
      <template v-for="(subject, index) in subjects" :key="subject.value">
        <router-link
          :to="{ name: 'BrowseStrategiesPage', query: { ...betaQuery, subject: subject.value } }"
          :class="CRUMB_LINK_CLASSES"
          >{{ subject.label }}</router-link
        ><template v-if="index < subjects.length - 1">, </template>
      </template>
    </li> <li class="inline-block">{{ title }}</li>
  </ol>
</template>
